export default function Cleaning() {
  const bookingLink =
    "https://outlook.office.com/book/CleaningServiceHopefulHorizonsNY@NETORG20608407.onmicrosoft.com/?ismsaljsauthenabled";

  return (
    <div className="booking-page">
      <header className="booking-header">
        <h1>Hopeful Horizons NY Cleaning Services</h1>
        <h2>*Westchester County Only*</h2>

      

       

        <p className="click-note">
  Use the calendar below to request an appointment, or select the button to open the booking page directly.
        </p>

        <a
          href={bookingLink}
          target="_blank"
          rel="noopener noreferrer"
          className="booking-link"
        >
          Book Cleaning Appointment →
        </a>
      </header>

      <iframe
        src={bookingLink}
        title="Hopeful Horizons NY Cleaning Service Booking"
        scrolling="yes"
      ></iframe>

      <style jsx>{`
        .booking-page {
          width: 100vw;
          height: 100vh;
          min-height: 100vh;
          margin: 0;
          padding: 0;
          overflow: hidden;
          display: flex;
          flex-direction: column;
          background: #ffffff;
        }

        .booking-header {
          width: 100%;
          padding: 14px 20px;
          background: #ffffff;
          border-bottom: 1px solid #e5e7eb;
          text-align: center;
          box-sizing: border-box;
        }

        .booking-header h1 {
          margin: 0;
          font-size: 24px;
          font-weight: 700;
          color: #1f2937;
        }

        .booking-header h2 {
          margin: 4px 0 0;
          font-size: 17px;
          font-weight: 600;
          color: #2f6f89;
        }

        .intro-text {
          margin: 6px 0 0;
          font-size: 15px;
          color: #4b5563;
        }

        .booking-note {
          max-width: 750px;
          margin: 8px auto 8px;
          font-size: 14px;
          color: #6b7280;
          line-height: 1.4;
        }

        .click-note {
          margin: 10px 0 8px;
          font-size: 14px;
          font-weight: 600;
          color: #374151;
        }

        .booking-link {
          display: inline-block;
          padding: 11px 18px;
          background: #2f6f89;
          color: #ffffff;
          text-decoration: none;
          border-radius: 8px;
          font-size: 15px;
          font-weight: 700;
          cursor: pointer;
          box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
          transition: background 0.2s ease, transform 0.2s ease;
        }

        .booking-link:hover {
          background: #24586d;
          transform: translateY(-1px);
        }

        .booking-page iframe {
          flex: 1;
          width: 100%;
          border: 0;
          display: block;
        }

        @media (max-width: 600px) {
          .booking-header {
            padding: 12px 14px;
          }

          .booking-header h1 {
            font-size: 20px;
          }

          .booking-header h2 {
            font-size: 15px;
          }

          .intro-text,
          .booking-note,
          .click-note {
            font-size: 13px;
          }

          .booking-link {
            width: 100%;
            max-width: 290px;
            box-sizing: border-box;
          }
        }
      `}</style>
    </div>
  );
}